export default {
  TEACHER: "Teacher",
};
